// v2026-06 — must match backend sandbox_league.SANDBOX_LEAGUE_ID. Admins/testers
// auto-enroll into this private high-budget arena on backend boot.
export const SANDBOX_LEAGUE_ID = 'sandbox_global';

/**
 * Decide which league should be active in the GlobalHeader selector.
 *
 * Returns the league object to select, or null when none are available.
 *
 * Rules:
 *  - Keep the current selection ONLY if it's actually in the visible list.
 *    (After a logout→guest / account switch the previous user's league id can
 *    linger in App state; a guest only sees the global leagues, so a stale
 *    private/sandbox id must be treated as "unset" — otherwise the Radix Select
 *    shows its placeholder and the header reads "No Team".)
 *  - Admins/testers default to the Sandbox Arena (₣1,000,000 budget).
 *  - Everyone else (incl. guests) defaults to the admin-provided GLOBAL YEARLY
 *    league (scope=global_annual), then any global, then the first league.
 */
export function pickDefaultLeague(leagues, currentId, user) {
  const list = Array.isArray(leagues) ? leagues : [];
  if (list.length === 0) return null;

  const current = currentId ? list.find((l) => l.id === currentId) : null;
  if (current) return current;

  const isTester = user?.role === 'admin' || user?.is_test_account;
  const sandbox = list.find((l) => l.id === SANDBOX_LEAGUE_ID);
  if (isTester && sandbox) return sandbox;

  const annualGlobal = list.find(
    (l) => l.scope === 'global_annual' && l.league_type === 'global'
  );
  const firstGlobal = list.find((l) => l.league_type === 'global');
  return annualGlobal || firstGlobal || list[0];
}

/**
 * 2026-11-01 (owner) — current leagues first, finished ones (past quarters)
 * under a "Final standings" group. The API already orders them this way and
 * flags `ended`; this only splits the list for rendering.
 */
export function splitLeagues(leagues) {
  const list = Array.isArray(leagues) ? leagues : [];
  return {
    current: list.filter((l) => !l.ended),
    past: list.filter((l) => l.ended),
  };
}

